import { Person } from '@weave/schema-gen-ts/dist/schemas/persons/v3/persons.pb';
import { InvoiceDetailModel } from '@frontend/api-invoices';
import { useTranslation } from '@frontend/i18n';
import { useViewAttachment } from '@frontend/payments-hooks';
import { useHasTTPAuth } from '@frontend/person-invoice-create';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { shell } from '@frontend/shell-utils';
import { Heading, Text, TextLink, WarningIndicatorSmall, useTooltip } from '@frontend/design-system';
import { styles, attachmentStyles } from './styles';

export type PaymentRequestAttachmentProps = {
  invoice: InvoiceDetailModel;
  person: Person | undefined;
};
export const PaymentRequestAttachment = ({ invoice, person }: PaymentRequestAttachmentProps) => {
  const { t } = useTranslation('payments');
  const { tooltipProps, triggerProps, Tooltip } = useTooltip({ placement: 'top', trigger: 'click' });
  const { viewAttachment, downloadAttachment } = useViewAttachment();
  const { enabled: ttpAuthEnabled } = useHasTTPAuth({ locationId: invoice?.locationId });
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.max });

  const attachmentName = invoice?.attachments?.[0]?.filename ?? '';
  const attachmentLink = invoice?.links?.attachment;

  return (
    <section css={styles.card}>
      <div css={styles.marginBottom}>
        <div css={attachmentStyles.attachmentHeading}>
          <Heading level={3}>{t('Attachments')}</Heading>
          {!person?.birthdate && ttpAuthEnabled && invoice?.attachments && (
            <div css={attachmentStyles.warningIndicator} {...triggerProps}>
              <WarningIndicatorSmall />
              <Tooltip {...tooltipProps} color='white'>
                <Text size='medium' color='white'>
                  {t(
                    'Attachment will be hidden from customer. Customer birthday is missing which is required for authentication.'
                  )}
                </Text>
              </Tooltip>
            </div>
          )}
        </div>
        <Text size={isMobile ? 'medium' : 'small'} color='light'>
          {t('Visible to the customer')}
        </Text>
      </div>
      {invoice?.hasAttachment && attachmentLink ? (
        <div css={attachmentStyles.attachmentNameRow}>
          <TextLink
            css={attachmentStyles.uploadAttachmentLink}
            onClick={
              shell.isShell
                ? () => downloadAttachment(attachmentLink, attachmentName)
                : () => viewAttachment(attachmentLink)
            }
          >
            {attachmentName}
          </TextLink>
        </div>
      ) : (
        <Text>{t('No attachments to display')}</Text>
      )}
    </section>
  );
};
